import { APIResponse } from "@/types/api";
import http from "@/composables/api";
import { RoleGroupDataPayload, RoleGroupDataResponse } from "@/types/interface/role-group";

async function createRoleGroup(payload: RoleGroupDataPayload) {
  return await http.post<APIResponse<RoleGroupDataResponse>>("role-group/create", payload);
}

async function updateRoleGroup(idRoleGroup = '', payload: RoleGroupDataPayload) {
  return await http.patch<APIResponse<RoleGroupDataResponse>>(`role-group/update?id=${idRoleGroup}`, payload);
}

async function getRoleGroup(page = 1, limit = 10, queryParam = "") {
  let pagination = true;
  if (page == 0){
    pagination = false;
  }
  return await http.get<APIResponse<RoleGroupDataResponse>>(`role-group?is_pagination=${pagination}&page=${page}&limit=${limit}${queryParam}`);
}

async function findRoleGroup(idRoleGroup = "") {
  return await http.get<APIResponse<RoleGroupDataResponse>>(`role-group/detail?id=${idRoleGroup}`);
}

async function deleteRoleGroup(idRoleGroup = "") {
  return await http.delete<APIResponse<RoleGroupDataResponse>>(`role-group/delete?id=${idRoleGroup}`);
}


export default {
  createRoleGroup,
  updateRoleGroup,
  getRoleGroup,
  findRoleGroup,
  deleteRoleGroup
};